import { Image, Pressable, StyleSheet, Text, View } from 'react-native';
import React from 'react';
// since these are designed as new design so using styles tag directly 
// this can be reused with themedview when moved to new architecture
const ElevateHomeCard = ({ onPress, action, triggerAction }) => {
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(Pressable, { onPress: handleAction, style: styles.card },
        React.createElement(View, { style: styles.textContainer },
            React.createElement(Text, { style: styles.title }, "Elevate your loan experience"),
            React.createElement(Text, { style: styles.subtitle }, "Unlocking the value of your mutual funds in a few clicks with DSP Finance!")),
        React.createElement(Image, { style: styles.coinImage, source: {
                uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/elevate_home_card_coin.png',
            } }),
        React.createElement(Image, { style: styles.bgImage, source: {
                uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/elevate_home_card_bg.png',
            } })));
};
export default ElevateHomeCard;
// Todo: Use new theme while revamping
const styles = StyleSheet.create({
    card: {
        backgroundColor: '#1434cb',
        borderRadius: 16,
        flexDirection: 'row',
        overflow: 'hidden',
    },
    textContainer: {
        flex: 1,
        paddingLeft: 12,
        paddingVertical: 16,
        paddingBottom: 24,
    },
    title: {
        color: 'white',
        fontSize: 16,
        fontWeight: '600',
        lineHeight: 24,
    },
    subtitle: {
        color: '#E4E7EC',
        marginTop: 8,
        fontSize: 12,
        lineHeight: 18,
        marginRight: 20
    },
    coinImage: {
        height: 95,
        width: 95,
        alignSelf: 'flex-end',
    },
    bgImage: {
        height: '100%',
        width: 120,
        alignSelf: 'flex-end',
        position: 'absolute',
        right: 0,
    },
});
